//console.log('Hello, bdfgdfgdfgdfg!');
document.addEventListener('DOMContentLoaded', function () {
  // Select the sticky element
  const masthead = document.getElementById('masthead');

  // Create a sentinel element to act as a trigger
  const sentinel = document.createElement('div');
  sentinel.style.position = 'absolute';
  sentinel.style.top = '0';
  sentinel.style.width = '100%';
  sentinel.style.height = '1px';
  sentinel.style.zIndex = '-1';

  masthead.parentNode.insertBefore(sentinel, masthead);

  // Function to add or remove the class based on the intersection state
  function handleIntersection(entries) {
    const entry = entries[0]; // There will always be only one entry
    if (!entry.isIntersecting) {
      masthead.classList.add('stuck');
    } else {
      masthead.classList.remove('stuck');
    }
  }

  // Create an intersection observer instance
  const observer = new IntersectionObserver(handleIntersection, {
    root: null,
    threshold: 0
  });

  // Start observing the sentinel element
  observer.observe(sentinel);
});


